import { legacy_createStore as createStore, combineReducers, applyMiddleware, Reducer } from "redux";
import {thunk}  from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import userReducer from "../reducers/userReducer";
import notificationReducer from "../reducers/notificationReducer";
import storage from "redux-persist/lib/storage";
import authReducer from "../reducers/authReducer";
import { LOGOUT } from "../actions/userActionCreator";

const appReducer = combineReducers({
    user: userReducer,
    notifications: notificationReducer,
    auth: authReducer
});

// Export RootState type for type-safe selectors
export type RootState = ReturnType<typeof appReducer>;

// LOGOUT resets every slice to initial state so no personal data survives
// into the next session. locale/rtl are preserved so Arabic users don't
// snap to LTR on the sign-in screen after signing out.
const rootReducer: Reducer = (state: RootState | undefined, action: any) => {
    if (action.type === LOGOUT && state) {
        const locale = state.user?.locale;
        const rtl = state.user?.rtl;
        const reset = appReducer(undefined, action) as RootState;
        return { ...reset, user: { ...reset.user, locale, rtl } };
    }
    return appReducer(state, action);
};

const persistConfig = {
    key: 'root',
    storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

let storeInstance: ReturnType<typeof createStore<typeof persistedReducer>> | null = null;
let persistorInstance: ReturnType<typeof persistStore> | null = null;

/**
 * Returns the singleton Redux store + persistor.
 * IMPORTANT: Never call createStore more than once in the app runtime.
 */
export default function configureStore() {
    if (!storeInstance) {
        storeInstance = createStore(persistedReducer, applyMiddleware(thunk));
        persistorInstance = persistStore(storeInstance);
    }
    return { store: storeInstance, persistor: persistorInstance };
}

export const getStore = () => configureStore().store;
export const getPersistor = () => configureStore().persistor;